__turbopack_context__.v({
  "container": "tCSEtW_container",
  "coordinateDot": "tCSEtW_coordinateDot",
  "coordinateDotsContainer": "tCSEtW_coordinateDotsContainer",
  "mapContainer": "tCSEtW_mapContainer",
  "mapContent": "tCSEtW_mapContent",
  "mapHelperText": "tCSEtW_mapHelperText",
  "mapImage": "tCSEtW_mapImage",
  "mapWrapper": "tCSEtW_mapWrapper",
  "marker": "tCSEtW_marker",
  "markerIcon": "tCSEtW_markerIcon",
  "markerLabel": "tCSEtW_markerLabel",
  "markersContainer": "tCSEtW_markersContainer",
});
